/* zimasya-matching-bundle:v2 */
(function () {
  'use strict';

  function componentKey(value) {
    var normalized = String(value || '')
      .toLowerCase()
      .replace(/\s+on\s+the\s+(left|right)\b/g, '')
      .replace(/\s*\/\s*(left|right)\s*side\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    var hasTableOrDesk = /\b(table|desk)\b/.test(normalized);
    var hasChair = /\bchairs?\b/.test(normalized);
    var isCompositeSet = hasTableOrDesk && hasChair && /\b(with|and)\b|\+/.test(normalized);
    if (isCompositeSet) return 'composite-table-chair-set';
    if (hasChair) return 'chair';
    if (hasTableOrDesk || /\b(workstation|seat|seater|partition|panel|executive|conference|meeting)\b/.test(normalized)) {
      return 'primary';
    }
    if (/\b(cabinet|storage)\b/.test(normalized)) return 'cabinet';
    return 'primary';
  }

  function componentLabel(value) {
    var raw = String(value || '');
    var normalized = raw.toLowerCase();
    var hasTableOrDesk = /\b(table|desk)\b/.test(normalized);
    var hasChair = /\bchairs?\b/.test(normalized);
    var isCompositeSet = hasTableOrDesk && hasChair && /\b(with|and)\b|\+/.test(normalized);
    if (isCompositeSet) return 'Table + Chairs Set';
    return raw
      .replace(/\s+on\s+the\s+(left|right)\b/ig, '')
      .replace(/\s*\/\s*(left|right)\s*side\b/ig, '')
      .replace(/\s*\*\s*(\d+)/g, ' × $1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function relatedProductLabel(product) {
    var productType = String((product && product.product_type) || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (productType && productType.toLowerCase() !== 'default title') {
      return productType;
    }
    var source = String((product && product.product_type) || '') + ' ' +
      String((product && product.title) || '');
    var normalized = source.toLowerCase();
    if (/\b(reception|executive|office|computer|writing|standing)\s+(desk|table)\b/.test(normalized) ||
        /\bdesk(s)?\b|\btable(s)?\b|\breception\s+counter\b/.test(normalized)) {
      return 'Reception Desk';
    }
    if (/\bchair(s)?\b|\bseating\b|\bseat\b/.test(normalized)) {
      return 'Chair';
    }
    if (/\bcabinet(s)?\b|\bstorage\b|\bbookcase\b|\bshelv(es|ing)\b|\bcredenza\b/.test(normalized)) {
      return 'Storage Cabinet';
    }
    return 'Matching Product';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  class ZimasyaMatchingBundle extends HTMLElement {
    connectedCallback() {
      if (this.__zmbReady) return;
      this.__zmbReady = true;
      this.mode = this.getAttribute('data-zmb-mode') || 'style';
      this.variants = [];
      this.relatedProducts = [];
      this.roleConfigs = [];
      this.selection = {};
      this.checked = {};
      this.quantity = {};
      this.mainVariantId = null;
      this.parseData();
      if (this.roleConfigs.length < 2) {
        this.remove();
        return;
      }
      this.cache();
      this.setInitialSelection();
      this.render();
      this.bind();
      this.mountIntoProductInfo();
      this.syncFromProductForm();
      window.setTimeout(this.mountIntoProductInfo.bind(this), 400);
      window.setTimeout(this.syncFromProductForm.bind(this), 650);
    }

    parseData() {
      if (this.mode === 'related') {
        var productSource = this.querySelector('[data-zmb-products]');
        try {
          this.relatedProducts = JSON.parse(productSource ? productSource.textContent : '[]')
            .filter(function (product) { return product && product.id && Array.isArray(product.variants); });
        } catch (error) {
          this.relatedProducts = [];
        }
        var seenProducts = {};
        this.relatedProducts.forEach(function (product) {
          var productKey = 'product-' + product.id;
          if (seenProducts[productKey]) return;
          seenProducts[productKey] = true;
          product.variants.forEach(function (variant) {
            if (!variant || !variant.id) return;
            this.variants.push(Object.assign({}, variant, {
              productKey: productKey,
              productId: product.id,
              productUrl: product.url || ''
            }));
          }, this);
          this.roleConfigs.push({
            key: productKey,
            label: relatedProductLabel(product),
            hint: product.is_current ? 'Current product' : 'Choose an option',
            linkUrl: product.url || ''
          });
        }, this);
        return;
      }
      var source = this.querySelector('[data-zmb-variants]');
      try {
        this.variants = JSON.parse(source ? source.textContent : '[]').filter(function (item) {
          return item && item.id;
        });
      } catch (error) {
        this.variants = [];
      }
      var seen = {};
      this.variants.forEach(function (variant) {
        var key = componentKey(variant.style);
        if (!key || seen[key]) return;
        seen[key] = true;
        this.roleConfigs.push({
          key: key,
          label: componentLabel(variant.style),
          hint: 'Choose the ' + componentLabel(variant.style).toLowerCase() + ' option'
        });
      }, this);
    }

    cache() {
      this.rows = this.querySelector('[data-zmb-rows]');
      this.body = this.querySelector('[data-zmb-body]');
      this.toggle = this.querySelector('[data-zmb-toggle]');
      this.total = this.querySelector('[data-zmb-total]');
      this.estimate = this.querySelector('[data-zmb-estimate]');
      this.submit = this.querySelector('[data-zmb-submit]');
      this.status = this.querySelector('[data-zmb-status]');
    }

    variantsFor(config) {
      if (this.mode === 'related') {
        return this.variants.filter(function (variant) {
          return variant.productKey === config.key && variant.available;
        });
      }
      return this.variants.filter(function (variant) {
        return componentKey(variant.style) === config.key && variant.available;
      });
    }

    variantById(id) {
      return this.variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    displayName(variant) {
      var values = [];
      if (variant.option1) values.push(variant.option1);
      if (variant.option3 && variant.option3 !== variant.option2) values.push(variant.option3);
      return values.length ? values.join(' / ') : variant.title;
    }

    findBest(config, preferred) {
      var candidates = this.variantsFor(config);
      if (!candidates.length) return null;
      if (preferred && candidates.some(function (item) { return String(item.id) === String(preferred.id); })) {
        return candidates.find(function (item) { return String(item.id) === String(preferred.id); });
      }
      if (preferred) {
        var sameColor = candidates.find(function (item) {
          return item.option1 && item.option1 === preferred.option1;
        });
        if (sameColor) return sameColor;
      }
      return candidates[0];
    }

    setInitialSelection() {
      var initialId = this.getAttribute('data-current-variant-id') ||
        new URLSearchParams(window.location.search).get('variant');
      var initial = this.variantById(initialId) || this.variants.find(function (variant) {
        return variant.available;
      });
      this.mainVariantId = initial ? initial.id : null;
      this.roleConfigs.forEach(function (config) {
        var selected = this.findBest(config, initial);
        if (selected) {
          this.selection[config.key] = selected.id;
          this.checked[config.key] = true;
          this.quantity[config.key] = 1;
        } else {
          this.checked[config.key] = false;
          this.quantity[config.key] = 1;
        }
      }, this);
    }

    bind() {
      var self = this;
      this.toggle.addEventListener('click', function () {
        var collapsed = self.classList.toggle('is-collapsed');
        self.toggle.setAttribute('aria-expanded', String(!collapsed));
        self.toggle.setAttribute('aria-label', collapsed ? 'Expand matching set' : 'Collapse matching set');
      });
      this.rows.addEventListener('change', function (event) {
        var select = event.target.closest('[data-zmb-select]');
        var checkbox = event.target.closest('[data-zmb-check]');
        var quantityInput = event.target.closest('[data-zmb-qty-input]');
        if (select) {
          self.selection[select.getAttribute('data-zmb-select')] = select.value;
          self.render();
        } else if (checkbox) {
          self.checked[checkbox.getAttribute('data-zmb-check')] = checkbox.checked;
          self.render();
        } else if (quantityInput) {
          var quantityKey = quantityInput.getAttribute('data-zmb-qty-input');
          self.quantity[quantityKey] = self.normalizeQuantity(quantityInput.value);
          quantityInput.value = self.quantity[quantityKey];
          self.render();
        }
      });
      this.rows.addEventListener('input', function (event) {
        var quantityInput = event.target.closest('[data-zmb-qty-input]');
        if (!quantityInput) return;
        var quantityKey = quantityInput.getAttribute('data-zmb-qty-input');
        self.quantity[quantityKey] = self.normalizeQuantity(quantityInput.value);
        self.updateSummary();
      });
      this.rows.addEventListener('click', function (event) {
        var checkbox = event.target.closest('[data-zmb-check]');
        if (checkbox) {
          var checkboxKey = checkbox.getAttribute('data-zmb-check');
          window.setTimeout(function () {
            var liveCheckbox = self.rows.querySelector('[data-zmb-check="' + checkboxKey + '"]');
            if (!liveCheckbox) return;
            self.checked[checkboxKey] = liveCheckbox.checked;
            self.render();
          }, 0);
          return;
        }
        var quantityButton = event.target.closest('[data-zmb-qty-action]');
        if (!quantityButton || quantityButton.disabled) return;
        var quantityKey = quantityButton.getAttribute('data-zmb-qty-key');
        var current = self.normalizeQuantity(self.quantity[quantityKey]);
        var action = quantityButton.getAttribute('data-zmb-qty-action');
        self.quantity[quantityKey] = action === 'increase'
          ? Math.min(99, current + 1)
          : Math.max(1, current - 1);
        var row = quantityButton.closest('.zmb__row');
        var input = row && row.querySelector('[data-zmb-qty-input]');
        if (input) input.value = self.quantity[quantityKey];
        self.render();
      });
      this.submit.addEventListener('click', function () {
        self.addSelectedToCart();
      });
      document.addEventListener('change', function (event) {
        var target = event.target;
        if (target && target.name === 'id' && target.closest('form[action*="/cart/add"]')) {
          self.syncFromProductForm();
        }
      });
      var observer = new MutationObserver(function () {
        self.syncFromProductForm();
      });
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) observer.observe(form, { subtree: true, attributes: true, attributeFilter: ['value'] });
    }

    mountIntoProductInfo() {
      var deliveryCard = document.querySelector(
        '.zmy-delivery-stock-guard-mount .zmy-delivery-card--made'
      );
      if (deliveryCard && deliveryCard.parentNode) {
        deliveryCard.setAttribute('hidden', 'hidden');
        deliveryCard.setAttribute('aria-hidden', 'true');
        this.classList.add('zmb--delivery-position');
        var deliveryMediaWrapper = document.querySelector('.t4s-product__media-wrapper');
        if (deliveryMediaWrapper) deliveryMediaWrapper.classList.add('zmb-media-sticky');
        var deliveryRecommendation = document.querySelector('.snippet-yl-aside-product');
        if (deliveryRecommendation) deliveryRecommendation.classList.add('zmb-aside-sticky');
        if (this.parentNode !== deliveryCard.parentNode || this.nextElementSibling !== deliveryCard) {
          deliveryCard.parentNode.insertBefore(this, deliveryCard);
        }
        return;
      }
      if (this.closest('.t4s-product__info-container, .product__info-container')) return;
      var info = document.querySelector(
        '.t4s-product__info-wrapper .t4s-product__info-container,' +
        ' .t4s-product__info-container,' +
        ' .product__info-container'
      );
      if (!info) return;
      var mediaWrapper = document.querySelector('.t4s-product__media-wrapper');
      if (mediaWrapper) mediaWrapper.classList.add('zmb-media-sticky');
      var recommendation = document.querySelector('.snippet-yl-aside-product');
      if (recommendation) recommendation.classList.add('zmb-aside-sticky');
      var anchor = info.querySelector(
        '.yl-main-product-description,' +
        ' .t4s-product__policies,' +
        ' .t4s-product-extra,' +
        ' .t4s-product-tabs-wrapper'
      );
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(this, anchor);
      } else {
        info.appendChild(this);
      }
    }

    syncFromProductForm() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = input && input.value;
      var current = this.variantById(id) || this.variantById(
        new URLSearchParams(window.location.search).get('variant')
      );
      if (!current || String(current.id) === String(this.mainVariantId)) return;
      this.mainVariantId = current.id;
      this.roleConfigs.forEach(function (config) {
        var selected = this.findBest(config, current);
        if (selected) this.selection[config.key] = selected.id;
      }, this);
      this.render();
    }

    normalizeQuantity(value) {
      var quantity = parseInt(value, 10);
      if (!Number.isFinite(quantity)) quantity = 1;
      return Math.min(99, Math.max(1, quantity));
    }

    render() {
      var self = this;
      this.rows.innerHTML = this.roleConfigs.map(function (config) {
        var candidates = self.variantsFor(config);
        var selected = self.variantById(self.selection[config.key]) || candidates[0];
        if (selected) self.selection[config.key] = selected.id;
        var unavailable = !selected;
        var checked = !!self.checked[config.key] && !unavailable;
        var quantity = self.normalizeQuantity(self.quantity[config.key]);
        self.quantity[config.key] = quantity;
        var controlsDisabled = unavailable || !checked;
        var image = selected && selected.image;
        var link = self.mode === 'related' && config.linkUrl ? config.linkUrl : '';
        var imageContent = image
          ? '<img class="zmb__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(config.label) + '">'
          : '<span class="zmb__image zmb__image--empty">N/A</span>';
        var imageMarkup = link
          ? '<a class="zmb__image-link" href="' + escapeHtml(link) + '" target="_blank" rel="noopener noreferrer" aria-label="Open ' + escapeHtml(config.label) + '">' + imageContent + '</a>'
          : imageContent;
        var nameMarkup = link
          ? '<a class="zmb__name zmb__name-link" href="' + escapeHtml(link) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(config.label) + '</a>'
          : '<div class="zmb__name">' + escapeHtml(config.label) + '</div>';
        var options = candidates.map(function (variant) {
          var isSelected = selected && String(selected.id) === String(variant.id);
          return '<option value="' + escapeHtml(variant.id) + '"' +
            (isSelected ? ' selected' : '') + '>' +
            escapeHtml(self.displayName(variant)) + '</option>';
        }).join('');
        var compare = selected && Number(selected.compare_at_price) > Number(selected.price)
          ? '<span class="zmb__compare">' + formatMoney(selected.compare_at_price) + '</span>'
          : '';
        return '<div class="zmb__row' +
          (unavailable ? ' is-unavailable' : '') +
          (!checked && !unavailable ? ' is-not-selected' : '') + '">' +
          imageMarkup +
          '<div class="zmb__details">' +
            nameMarkup +
            '<div class="zmb__hint">' + escapeHtml(unavailable ? 'Currently unavailable' : config.hint) + '</div>' +
          '</div>' +
          '<select class="zmb__select" data-zmb-select="' + config.key + '"' +
          (controlsDisabled ? ' disabled' : '') + ' aria-label="' + escapeHtml(config.label) + ' options">' +
            (options || '<option>Unavailable</option>') +
          '</select>' +
          '<div class="zmb__price">' + (selected ? formatMoney(selected.price) : '') + compare + '</div>' +
          '<div class="zmb__tools">' +
          '<div class="zmb__quantity" aria-label="Quantity for ' + escapeHtml(config.label) + '">' +
            '<button class="zmb__qty-button" type="button" data-zmb-qty-action="decrease" data-zmb-qty-key="' + config.key + '"' +
              (controlsDisabled || quantity <= 1 ? ' disabled' : '') + ' aria-label="Decrease quantity">-</button>' +
            '<input class="zmb__qty-input" type="number" min="1" max="99" value="' + quantity + '"' +
              ' data-zmb-qty-input="' + config.key + '"' + (controlsDisabled ? ' disabled' : '') +
              ' aria-label="Quantity for ' + escapeHtml(config.label) + '">' +
            '<button class="zmb__qty-button" type="button" data-zmb-qty-action="increase" data-zmb-qty-key="' + config.key + '"' +
              (controlsDisabled || quantity >= 99 ? ' disabled' : '') + ' aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<input class="zmb__check" type="checkbox" data-zmb-check="' + config.key + '"' +
          (checked ? ' checked' : '') + (unavailable ? ' disabled' : '') +
          ' aria-label="Select ' + escapeHtml(config.label) + '">' +
          '</div>' +
        '</div>';
      }).join('');
      this.updateSummary();
    }

    updateSummary() {
      var bundle = this;
      var selected = this.roleConfigs.map(function (config) {
        return {
          config: config,
          variant: this.variantById(this.selection[config.key])
        };
      }, this).filter(function (item) {
        return item.variant && item.variant.available && this.checked[item.config.key];
      }, this);
      var total = selected.reduce(function (sum, item) {
        var quantity = bundle.normalizeQuantity(bundle.quantity[item.config.key]);
        return sum + Number(item.variant.price || 0) * quantity;
      }, 0);
      this.total.textContent = formatMoney(total);
      this.estimate.textContent = formatMoney(Math.round(total * 0.95));
      this.submit.disabled = selected.length < 2;
      this.submit.textContent = selected.length < 2 ? 'SELECT AT LEAST 2 ITEMS' : 'ADD SELECTED TO CART';
    }

    async addSelectedToCart() {
      var self = this;
      var selected = this.roleConfigs.map(function (config) {
        var variant = self.variantById(self.selection[config.key]);
        return variant && variant.available && self.checked[config.key]
          ? { id: Number(variant.id), quantity: self.normalizeQuantity(self.quantity[config.key]) }
          : null;
      }).filter(Boolean);
      if (selected.length < 2) return;
      this.submit.disabled = true;
      this.status.textContent = 'Adding your matching set…';
      try {
        var response = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: selected })
        });
        if (!response.ok) {
          var errorBody = await response.json().catch(function () { return {}; });
          throw new Error(errorBody.description || 'Unable to add the selected items.');
        }
        this.status.textContent = 'Added to cart. Opening your cart…';
        window.setTimeout(function () {
          window.location.assign(rootUrl() + 'cart');
        }, 450);
      } catch (error) {
        this.status.textContent = error.message || 'Unable to add the selected items.';
        this.submit.disabled = false;
        this.updateSummary();
      }
    }
  }

  if (!customElements.get('zimasya-matching-bundle')) {
    customElements.define('zimasya-matching-bundle', ZimasyaMatchingBundle);
  }
})();
